export default __webpack_public_path__ + "static/bootleg-e4df986e71cb8dca43ea5520aaa190bd.jpg";